var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Share as ShareIcon } from "@mui/icons-material";
import { ClickAwayListener, Grid, IconButton, Paper, Popper } from "@mui/material";
import { NkmbIconFb } from "@nitra/nkmb-theme";
import { useState } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
export var ShareArea = function (props) {
    var brightText = props.brightText, sx = props.sx, iconSx = props.iconSx;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(false), copySuccess = _b[0], setCopySuccess = _b[1];
    var handleClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    var open = Boolean(anchorEl);
    var id = open ? "social-share-popper" : undefined;
    function getLink() {
        if (props.shareUrl === undefined) {
            return window.location.href;
        }
        else if (props.shareUrl.startsWith("https://")) {
            return props.shareUrl;
        }
        else {
            return window.location.origin + props.shareUrl;
        }
    }
    var handleFbShare = function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(getLink()), 'facebook-share-dialog', 'width=626,height=436');
    };
    var handleTwitterShare = function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.open("https://twitter.com/share?url=".concat(getLink()), 'twitter-share-dialog', 'width=626,height=436');
    };
    var handleCopyLink = function (event) {
        event.preventDefault();
        event.stopPropagation();
        navigator.clipboard.writeText(getLink())
            .then(function () {
            setCopySuccess(true);
            setTimeout(function () { return setCopySuccess(false); }, 2000);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ "aria-label": "share", sx: __assign({ color: brightText ? "background.paper" : "unset", p: 0, ml: "auto" }, sx), onClick: handleClick }, { children: _jsx(ShareIcon, { sx: __assign({ width: "16px", height: "16px" }, iconSx) }) })), _jsx(ClickAwayListener, __assign({ onClickAway: function () { return setAnchorEl(null); } }, { children: _jsx(Popper, __assign({ id: id, open: open, anchorEl: anchorEl, placement: "bottom", sx: { zIndex: 100 } }, { children: _jsx(Paper, __assign({ sx: { padding: 1 } }, { children: _jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsx(IconButton, __assign({ onClick: handleFbShare }, { children: _jsx(NkmbIconFb, {}) })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(IconButton, __assign({ onClick: handleCopyLink }, { children: copySuccess ?
                                            _jsx(CheckIcon, {}) :
                                            _jsx(ContentCopyIcon, {}) })) }))] })) })) })) }))] }));
};
